import { Service, Project, TeamMember, Testimonial } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const services: Service[] = [
  {
    id: 'design-interieur-residentiel',
    title: 'Design d\'Intérieur Résidentiel',
    description: 'Transformez votre maison en un espace de vie élégant et fonctionnel qui reflète votre personnalité. Nous créons des intérieurs sur mesure alliant confort, esthétique et praticité.',
    icon: 'Home',
    features: [
      'Conception d\'espaces de vie personnalisés',
      'Sélection de matériaux premium (marbre, bois massif, cuir)',
      'Optimisation de l\'éclairage naturel et artificiel',
      'Aménagement de chambres, salons et cuisines',
      'Intégration de solutions de rangement intelligentes',
    ],
    imageKey: IMAGES.INTERIOR_DESIGN_1,
  },
  {
    id: 'design-commercial',
    title: 'Aménagement Commercial',
    description: 'Créez des espaces commerciaux qui captivent vos clients et optimisent votre activité. Bureaux modernes, boutiques élégantes et restaurants raffinés conçus pour le succès.',
    icon: 'Building2',
    features: [
      'Design de bureaux professionnels et ergonomiques',
      'Aménagement de boutiques et showrooms',
      'Conception de restaurants et espaces hôteliers',
      'Optimisation de la circulation et de l\'expérience client',
      'Intégration de l\'identité de marque dans l\'espace',
    ],
    imageKey: IMAGES.OFFICE_DESIGN_1,
  },
  {
    id: 'consultation-design',
    title: 'Consultation Design',
    description: 'Bénéficiez de l\'expertise de nos designers pour affiner votre vision et prendre les bonnes décisions. Conseils professionnels sur les couleurs, matériaux et agencements.',
    icon: 'Lightbulb',
    features: [
      'Analyse de vos besoins et de votre style de vie',
      'Recommandations de palettes de couleurs tendance 2026',
      'Conseils sur le choix de matériaux et finitions',
      'Plans d\'aménagement et optimisation d\'espace',
      'Accompagnement dans la sélection de mobilier',
    ],
    imageKey: IMAGES.INTERIOR_DESIGN_2,
  },
  {
    id: 'ameublement-sur-mesure',
    title: 'Ameublement Sur Mesure',
    description: 'Mobilier exclusif conçu et fabriqué selon vos spécifications. Pièces uniques alliant artisanat traditionnel et design contemporain pour un intérieur d\'exception.',
    icon: 'Armchair',
    features: [
      'Création de meubles sur mesure (canapés, tables, armoires)',
      'Sélection de tissus et matériaux premium',
      'Fabrication artisanale de haute qualité',
      'Design Mid-Century Modern et Japandi',
      'Pièces sculpturales et éléments décoratifs uniques',
    ],
    imageKey: IMAGES.FURNITURE_SHOWROOM_1,
  },
];

export const projects: Project[] = [
  {
    id: 'villa-cocody',
    title: 'Villa Moderne Cocody',
    category: 'residential',
    description: 'Rénovation complète d\'une villa de prestige avec salon ouvert, cuisine équipée et chambres élégantes. Palette de couleurs chaudes (chocolat, doré) et matériaux naturels.',
    imageKey: IMAGES.INTERIOR_DESIGN_1,
    year: 2025,
    location: 'Cocody, Abidjan',
  },
  {
    id: 'bureau-plateau',
    title: 'Bureaux Exécutifs Plateau',
    category: 'commercial',
    description: 'Aménagement de bureaux modernes pour une entreprise tech. Design minimaliste avec mobilier ergonomique, espaces collaboratifs et salles de réunion équipées.',
    imageKey: IMAGES.OFFICE_DESIGN_1,
    year: 2025,
    location: 'Plateau, Abidjan',
  },
  {
    id: 'showroom-marcory',
    title: 'Showroom Mobilier Marcory',
    category: 'furniture',
    description: 'Conception et installation d\'un showroom de mobilier haut de gamme. Mise en scène élégante avec éclairage d\'ambiance et zones thématiques (salon, chambre, bureau).',
    imageKey: IMAGES.FURNITURE_SHOWROOM_1,
    year: 2026,
    location: 'Marcory, Abidjan',
  },
  {
    id: 'appartement-riviera',
    title: 'Appartement Contemporain Riviera',
    category: 'residential',
    description: 'Transformation d\'un appartement en espace de vie moderne. Cuisine ouverte, salon lumineux avec grandes baies vitrées et chambres cosy aux tons neutres.',
    imageKey: IMAGES.INTERIOR_DESIGN_2,
    year: 2025,
    location: 'Riviera, Abidjan',
  },
  {
    id: 'restaurant-zone4',
    title: 'Restaurant Gastronomique Zone 4',
    category: 'commercial',
    description: 'Design d\'intérieur pour un restaurant haut de gamme. Ambiance chaleureuse avec banquettes en cuir, éclairage tamisé et matériaux nobles (bois, marbre, laiton).',
    imageKey: IMAGES.INTERIOR_DESIGN_10,
    year: 2026,
    location: 'Zone 4, Abidjan',
  },
  {
    id: 'suite-parentale-angre',
    title: 'Suite Parentale Luxe Angré',
    category: 'residential',
    description: 'Création d\'une suite parentale élégante avec dressing sur mesure, salle de bain en marbre et chambre aux tons apaisants. Mobilier Mid-Century et textiles velours.',
    imageKey: IMAGES.BEDROOM_DESIGN_1,
    year: 2025,
    location: 'Angré, Abidjan',
  },
];

export const teamMembers: TeamMember[] = [
  {
    id: 'founder-designer',
    name: 'Yao Kouamé',
    role: 'Fondateur & Designer Principal',
    bio: 'Passionné par le design d\'intérieur depuis plus de 10 ans, Yao allie expertise internationale et connaissance approfondie du marché ivoirien. Spécialiste des tendances 2026 et du mobilier sur mesure.',
  },
  {
    id: 'interior-architect',
    name: 'Aya N\'Guessan',
    role: 'Architecte d\'Intérieur',
    bio: 'Diplômée en architecture d\'intérieur, Aya excelle dans la conception d\'espaces commerciaux et résidentiels. Son approche combine fonctionnalité et esthétique contemporaine.',
  },
  {
    id: 'furniture-designer',
    name: 'Kofi Mensah',
    role: 'Designer Mobilier',
    bio: 'Artisan créatif spécialisé dans la fabrication de meubles sur mesure. Kofi transforme les idées en pièces uniques alliant tradition artisanale et design moderne.',
  },
];

export const testimonials: Testimonial[] = [
  {
    id: 'testimonial-1',
    clientName: 'Madame Adjoua K.',
    projectType: 'Villa Résidentielle',
    content: 'YKE Multi-Service a transformé notre maison en un véritable havre de paix. L\'équipe a su comprendre nos besoins et créer un espace élégant et fonctionnel. Le mobilier sur mesure est d\'une qualité exceptionnelle.',
    rating: 5,
  },
  {
    id: 'testimonial-2',
    clientName: 'Monsieur Traoré B.',
    projectType: 'Bureaux Entreprise',
    content: 'Professionnalisme et créativité au rendez-vous ! Nos nouveaux bureaux reflètent parfaitement l\'image moderne de notre entreprise. Les délais ont été respectés et le résultat dépasse nos attentes.',
    rating: 5,
  },
  {
    id: 'testimonial-3',
    clientName: 'Famille Diallo',
    projectType: 'Appartement Contemporain',
    content: 'Nous sommes ravis de notre collaboration avec YKE. Leur expertise en design d\'intérieur et leur sens du détail ont fait toute la différence. Notre appartement est maintenant un espace de vie magnifique.',
    rating: 5,
  },
];